import { actionTypes } from "./action-types";
import { mutationTypes } from "./mutation-types";
import { getterTypes } from "./getter-types";
import { validateMessages } from "@/config";
import Vue from "vue";
import {
  createCart,
  fetchCart,
  addToCart,
  setCartToken,
  removeFromCart,
  editCart,
  getCartItem,
  dropCart,
} from "@/services/cart";

const CartModule = {
  namespaced: true,
  strict: true,
  state: {
    cart: null,
    cart_item: null,
  },
  actions: {
    [actionTypes.CREATE_CART]({ commit }) {
      return new Promise((resolve, reject) => {
        createCart()
          .then((response) => {
            setCartToken(response.data.tokenValue);
            commit(mutationTypes.SET_CART, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.DROP_CART]({ commit }) {
      return new Promise((resolve, reject) => {
        dropCart()
          .then((response) => {
            commit(mutationTypes.SET_CART, null);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_CART]({ commit }) {
      return new Promise((resolve, reject) => {
        fetchCart()
          .then((response) => {
            commit(mutationTypes.SET_CART, response.data);
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                Vue.notify({
                  group: validateMessages.group,
                  type: "error",
                  title: validateMessages.error.header,
                  text: "Twoja karta wygasła.",
                });
              }
            } else {
              Vue.notify({
                group: validateMessages.group,
                type: "error",
                title: validateMessages.error.header,
                text: "Wystąpił niezidentyfikowany problem.",
              });
            }
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_TO_CART]({ commit }, product) {
      return new Promise((resolve, reject) => {
        addToCart(product)
          .then((response) => {
            commit(mutationTypes.SET_CART, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_UPDATE_CART]({ commit }, data) {
      return new Promise((resolve, reject) => {
        editCart(data)
          .then((response) => {
            commit(mutationTypes.SET_CART, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.REMOVE_FROM_CART]({ dispatch }, productId) {
      return new Promise((resolve, reject) => {
        removeFromCart(productId)
          .then((response) => {
            dispatch(actionTypes.FETCH_CART);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_CART_ITEM]({ commit }, id) {
      return new Promise((resolve, reject) => {
        getCartItem(id)
          .then((response) => {
            commit(mutationTypes.SET_CART_ITEM, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
  },
  mutations: {
    [mutationTypes.SET_CART](state, payload) {
      state.cart = payload;
    },
    [mutationTypes.SET_CART_ITEM](state, payload) {
      state.cart_item = payload;
    },
  },
  getters: {
    [getterTypes.GET_CART](state) {
      return state.cart;
    },
    [getterTypes.GET_CART_ITEM](state) {
      return state.cart_item;
    },
  },
};

export { CartModule };
